import { useEffect, useRef, useState } from "react";
import { Redirect } from "react-router-dom";
import ApiService from "../service/ApiService";
import { useUser } from "../context/UserContext";
import { resolveStartPage } from "../start-pages";

/**
 * Kök adresin (/) karşılığı: kullanıcıyı açılış sayfasına yollar.
 *
 * Kararı vermeden ÖNCE profili sunucudan tazeler. Sebep: giriş akışında bağlamdaki kullanıcı
 * yalnız token'dan ibaret olabiliyor — profil (izinler ve açılış sayfası tercihi) daha sonra,
 * MainLayout çizilirken çekiliyordu. O yüzden yönlendirme hep varsayılana düşüyordu. Ayrıca
 * localStorage'daki kullanıcı bayat olabilir: yönetici tercihi yeni değiştirdiyse eski değer
 * okunurdu.
 */
export default function StartPageRedirect() {
    const { user, setUser } = useUser();
    const [target, setTarget] = useState(null);

    // Uç başarısız olursa elde ne varsa onunla karar veririz; kullanıcı kapıda kalmasın.
    const fallbackUser = useRef(user);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            const res = await ApiService.User.Information();

            if (cancelled)
                return;

            if (res.success) {
                setUser(res.data);
                setTarget(resolveStartPage(res.data));
            }
            else {
                setTarget(resolveStartPage(fallbackUser.current));
            }
        })();

        return () => { cancelled = true };
    }, []);

    if (!target)
        return null;

    return <Redirect to={target} />;
}
